// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","703":"LazyIdentificationBusinessForm","886":"LazyInvitationStep","954":"LazyBusinessInfoFormComponent"}[chunkId] + "." + {"99":"b34bebb59ff71b6ca518","703":"d563960aa84cec701470","886":"72d19a20ee9e4ec3a4c4","954":"e87889ab5e0e40a56a46"}[chunkId] + ".js";
};